export const HAS_CLOSED_SIGNUP_MODAL = "has-closed-signup-modal";
